import React, { useState, useEffect } from "react";
import Sidebar from "../common/Sidebar";
import "../../styles/AdminProjectsStyles.css";
import API_URL from "../../config";

const AdminProjects = () => {
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState({
    title: "",
    description: "",
    location: "",
    city: "",
    status: "",
  });
  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);

  const token = localStorage.getItem("adminToken");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${API_URL}/api/projects`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await response.json();
        if (result && Array.isArray(result.data)) {
          setProjects(result.data);
        } else {
          console.error("Formato de datos inesperado:", result);
          setProjects([]);
        }
      } catch (error) {
        console.error("Error al cargar proyectos:", error);
      }
    };
    fetchProjects();
  }, [token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    setPreviewImages(files.map((file) => URL.createObjectURL(file)));
  };

  // Opcional: mover imágenes arriba/abajo (solo si lo necesitas)
  const handleImageReorder = (startIndex, endIndex) => {
    const reordered = [...images];
    const [removed] = reordered.splice(startIndex, 1);
    reordered.splice(endIndex, 0, removed);
    setImages(reordered);
    setPreviewImages(reordered.map((file) => URL.createObjectURL(file)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar que se envíen todos los campos requeridos por el modelo
    if (!form.title || !form.description || !form.location || !form.city || !form.status) {
      alert("Por favor completa todos los campos obligatorios.");
      return;
    }

    // Construimos un FormData para subir datos + archivos
    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));
    images.forEach((image) => formData.append("images", image));

    try {
      const response = await fetch(`${API_URL}/api/projects`, {
        method: "POST",
        headers: {
          // IMPORTANTE: no poner Content-Type manualmente, fetch + FormData se encargan
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Error al crear el proyecto");
      }

      // El backend responde con el objeto creado (según tu ProjectsController)
      const newProject = await response.json();

      // Actualizamos la lista de proyectos
      setProjects((prev) => [...prev, newProject]);

      // Limpiamos formulario e imágenes
      setForm({ title: "", description: "", location: "", city: "", status: "" });
      setImages([]);
      setPreviewImages([]);
    } catch (error) {
      console.error("Error al crear proyecto:", error);
      alert("Error al crear proyecto: " + error.message);
    }
  };

  const toggleProjectActiveStatus = async (id, isActive) => {
    try {
      const response = await fetch(`${API_URL}/api/projects/${id}`
, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ isActive: !isActive }),
      });
      if (!response.ok) throw new Error("Error al cambiar el estado del proyecto");

      const updatedProject = await response.json();
      setProjects((prev) =>
        prev.map((project) => (project._id === id || project.id === id ? updatedProject : project))
      );
    } catch (error) {
      console.error("Error al cambiar el estado del proyecto:", error);
    }
  };

  const deleteProject = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/projects/${id}`
, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Error al eliminar el proyecto");

      setProjects((prev) => prev.filter((project) => project._id !== id && project.id !== id));
    } catch (error) {
      console.error("Error al eliminar proyecto:", error);
    }
  };

  return (
    <div
      className="admin-projects-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/adminImages/projects.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "100vh",
      }}
    >
      <Sidebar />
      <div className="admin-projects-content" style={{ marginLeft: "280px", padding: "20px" }}>
        <header className="admin-projects-header">
          <h1>Gestión de Proyectos</h1>
        </header>
        <hr />

        <h2>Crear Proyecto</h2>
        <form className="row g-3" onSubmit={handleSubmit}>
          {/* Título */}
          <div className="col-md-6">
            <label htmlFor="title" className="form-label">
              Título del Proyecto
            </label>
            <input
              type="text"
              className="form-control"
              id="title"
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </div>

          {/* Descripción */}
          <div className="col-md-6">
            <label htmlFor="description" className="form-label">
              Descripción del Proyecto
            </label>
            <textarea
              className="form-control"
              id="description"
              name="description"
              value={form.description}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          {/* Ubicación */}
          <div className="col-md-6">
            <label htmlFor="location" className="form-label">
              Ubicación del Proyecto
            </label>
            <input
              type="text"
              className="form-control"
              id="location"
              name="location"
              value={form.location}
              onChange={handleChange}
              required
            />
          </div>

          {/* Ciudad */}
          <div className="col-md-6">
            <label htmlFor="city" className="form-label">
              Ciudad del Proyecto
            </label>
            <input
              type="text"
              className="form-control"
              id="city"
              name="city"
              value={form.city}
              onChange={handleChange}
              required
            />
          </div>

          {/* Estado (status) */}
          <div className="col-md-6">
            <label htmlFor="status" className="form-label">
              Estado del Proyecto
            </label>
            <select
              id="status"
              name="status"
              className="form-select"
              value={form.status}
              onChange={handleChange}
              required
            >
              <option value="">Seleccione</option>
              <option value="En ejecución">En ejecución</option>
              <option value="Finalizado">Finalizado</option>
            </select>
          </div>

          {/* Imágenes */}
          <div className="col-md-6">
            <label htmlFor="images" className="form-label">
              Imágenes del Proyecto
            </label>
            <input
              type="file"
              className="form-control"
              id="images"
              multiple
              onChange={handleImageChange}
            />
            <div className="mt-3 d-flex flex-wrap">
              {previewImages.map((src, idx) => (
                <div key={idx} className="me-2">
                  <img
                    src={src}
                    alt={`Preview ${idx}`}
                    style={{ width: "100px", height: "auto" }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary mt-1"
                    onClick={() =>
                      handleImageReorder(idx, idx === 0 ? idx : idx - 1)
                    }
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary mt-1"
                    onClick={() =>
                      handleImageReorder(
                        idx,
                        idx === images.length - 1 ? idx : idx + 1
                      )
                    }
                  >
                    ↓
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12">
            <button type="submit" className="btn btn-primary">
              Crear Proyecto
            </button>
          </div>
        </form>

        <h2 className="mt-5">Listado de Proyectos</h2>
        <ul className="list-group">
          {projects.map((project) => (
            <li
              key={project.id || project._id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <span>
                <strong>{project.title}</strong> - {project.city}
              </span>
              <div>
                {project.isActive ? (
                  <button
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => toggleProjectActiveStatus(project.id || project._id, project.isActive)}
                  >
                    Deshabilitar
                  </button>
                ) : (
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => toggleProjectActiveStatus(project.id || project._id, project.isActive)}
                  >
                    Habilitar
                  </button>
                )}
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteProject(project.id || project._id)}
                >
                  Eliminar
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminProjects;
